module.exports = __webpack_public_path__ + "assets/img/2.4d85e8ff.jpg";